/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {GenericModelViewerListNode} from "../../../Components/Common/GenericModelViewerListNode";
import React, {useMemo} from "react";
import * as listComponents from "../../../Components/Common/List/ListComponents";

export const ChildrenFieldViewer = (props) => {
	
	const { CustomData, FieldDef, OnValidationUpdate, RootData, Value, children } = props;
	
	const { model, nonMutable, orderable, sortKey, listComponentOverride, customData } = FieldDef.association;
	
	let primaryKeyName = model.getPrimaryKeyName();
	
	const defaultComponentName = (nonMutable ? 'NonMutableList' : 'MutableList');
	
	const componentName =
		(listComponentOverride ? listComponentOverride : defaultComponentName);
	
	const ListComponent = listComponents?.[componentName] ?? null;
	
	if (ListComponent == null) {
		console.log('ListComponent with name: `' + componentName + '` was not defined.')
		return null;
	}
	
	const additionalTypeProps = useMemo(() => ({
		FieldDef,
		Editable: false,
		OnValidationUpdate,
		CustomData: { ...CustomData, ...customData },
	}),[FieldDef, OnValidationUpdate, CustomData, customData]);

	return (
		<ListComponent
			Editable={false}
			DataTypeName={FieldDef.title}
			Data={Value}
			Type={GenericModelViewerListNode}
			AdditionalTypeProps={additionalTypeProps}
			RootData={RootData}
			PrimaryKeyName={primaryKeyName}
			sortKey={sortKey ?? orderable}
		>{children}</ListComponent>
	);
};
